import { SeaObjectType } from "../../types/treasure-hunt";
import { SEA_OBJECT_ICONS, SEA_OBJECT_NAMES } from "../../constants/treasure-hunt";

interface SeaObjectsPanelProps {
  selectedSeaObject: SeaObjectType | null;
  onSelect: (objectType: SeaObjectType) => void;
  position: "right" | "bottom";
  onPositionChange: (position: "right" | "bottom") => void;
}

export const SeaObjectsPanel = ({
  selectedSeaObject,
  onSelect,
  position,
  onPositionChange,
}: SeaObjectsPanelProps) => {
  return (
    <div
      className={`fixed z-10 bg-blue-50 shadow-2xl border-blue-300 ${
        position === "right"
          ? "right-0 top-0 bottom-0 w-full lg:w-64 border-l-4 overflow-y-auto p-5"
          : "bottom-0 left-0 right-0 h-auto max-h-64 border-t-4 overflow-y-hidden p-3"
      }`}
    >
      <div
        className={`flex justify-between items-center mb-3 ${
          position === "bottom" ? "flex-shrink-0" : ""
        }`}
      >
        <h2
          className={`text-gray-800 font-bold ${
            position === "right" ? "text-lg" : "text-base"
          }`}
        >
          Морские предметы
        </h2>
        <button
          onClick={() =>
            onPositionChange(position === "right" ? "bottom" : "right")
          }
          className={`bg-blue-500 hover:bg-blue-600 text-white rounded-lg transition-colors font-semibold flex-shrink-0 ${
            position === "right"
              ? "px-3 py-2 text-sm"
              : "px-2 py-1.5 text-xs"
          }`}
        >
          {position === "right" ? "↓ Вниз" : "→ Вправо"}
        </button>
      </div>

      <div
        className={`flex ${
          position === "right"
            ? "flex-col gap-4 overflow-y-auto"
            : "flex-row gap-4 overflow-x-auto overflow-y-hidden"
        }`}
      >
        {/* Все объекты вместе */}
        {Object.values(SeaObjectType).map((objectType) => (
          <button
            key={objectType}
            onClick={() => onSelect(objectType)}
            className={`flex items-center gap-2.5 rounded-lg transition-all ${
              selectedSeaObject === objectType
                ? "bg-blue-500 text-white scale-105 ring-2 ring-blue-600 shadow-lg"
                : "bg-white text-gray-800 hover:bg-blue-100 border border-blue-200"
            } ${
              position === "bottom"
                ? "flex-shrink-0 min-w-[160px] px-3 py-2"
                : "px-3 py-2.5"
            }`}
          >
            <img
              src={SEA_OBJECT_ICONS[objectType]}
              alt={SEA_OBJECT_NAMES[objectType]}
              className={`object-cover rounded border-2 border-blue-200 ${
                position === "bottom" ? "w-11 h-11" : "w-12 h-12"
              }`}
            />
            <div className="flex-1 text-left">
              <span
                className={`block font-semibold ${
                  position === "bottom" ? "text-xs" : "text-sm"
                }`}
              >
                {SEA_OBJECT_NAMES[objectType]}
              </span>
            </div>
          </button>
        ))}
      </div>
    </div>
  );
};
